import { useSelector } from "react-redux";
import { selectUserData, selectUserToken } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import OptifundDashboardMobile from "../../../../components/AssetManagement/Overview/OptifundDashboard/OptifundDashboardMobile/OptifundDashboardMobile";
import {
  OPTIFUND_SITE_NAME,
  userHasOptifundSiteAccess,
} from "../../../../components/AssetManagement/Overview/OptifundDashboard/optifundSiteAccess";
import { useWebsiteSharedUid } from "../../../../customHooks/useWebsiteSharedUid";
import { useLockWorkspaceToSite } from "../../../../customHooks/useLockWorkspaceToSite";

// Same two independent gates as the desktop screen (OptifundDashboardScreen.tsx):
// the module-level permission (view_optifund_dashboard, under "overview") and
// site-level access - Optifund data comes from one specific site, so a user
// without access to that site must see the 403 page instead of another
// site's data. This screen additionally locks the global workspace selector
// to that site while it's mounted (see useLockWorkspaceToSite) - the desktop
// screen intentionally does not do this (checklist Section 10.6).
export default function OptifundDashboardMobileScreen() {
  const userToken = useSelector(selectUserToken);
  const userData = useSelector(selectUserData);
  const hasOptifundDashboardPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "overview",
    "view_optifund_dashboard"
  );
  const hasSiteAccess = userHasOptifundSiteAccess(userData);
  const websiteSharedUid = useWebsiteSharedUid(OPTIFUND_SITE_NAME);

  useLockWorkspaceToSite(OPTIFUND_SITE_NAME, hasOptifundDashboardPermission && hasSiteAccess);

  return hasOptifundDashboardPermission && hasSiteAccess && websiteSharedUid ? (
    <OptifundDashboardMobile userToken={userToken} websiteSharedUid={websiteSharedUid} />
  ) : (
    <Page404 />
  );
}
